import { useEffect, useState } from "react";
import { http, formatApiErrorDetail } from "../../lib/api";

const STARTER_HTML = `<h2 style="font-family:Georgia,serif;font-size:22px;margin:0 0 8px 0;">Titulares del día</h2>
<ul style="font-size:17px;line-height:1.55;padding-left:20px;margin:0 0 20px 0;">
  <li><a href="https://politicareal.com" style="color:#8B0000;">Encabezado uno</a> — breve contexto.</li>
  <li><a href="https://politicareal.com" style="color:#8B0000;">Encabezado dos</a> — breve contexto.</li>
  <li><a href="https://politicareal.com" style="color:#8B0000;">Encabezado tres</a> — breve contexto.</li>
</ul>
<h3 style="font-family:Georgia,serif;font-size:18px;margin:20px 0 6px 0;">Aprobación presidencial (promedio)</h3>
<p style="font-size:16px;line-height:1.55;margin:0 0 20px 0;">— comentario editorial breve —</p>
<h3 style="font-family:Georgia,serif;font-size:18px;margin:20px 0 6px 0;">Opinión destacada</h3>
<p style="font-size:16px;line-height:1.55;margin:0;">— cita o párrafo corto de la opinión del día —</p>`;

export default function NewsletterTab() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [subject, setSubject] = useState("POLÍTICA REAL · Briefing del día");
  const [html, setHtml] = useState(STARTER_HTML);
  const [sending, setSending] = useState(false);
  const [composing, setComposing] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const [schedule, setSchedule] = useState(null);
  const [savingSched, setSavingSched] = useState(false);

  const loadStatus = async () => {
    setLoading(true);
    try {
      const [{ data }, { data: s }] = await Promise.all([
        http.get("/admin/newsletter/status"),
        http.get("/admin/newsletter/schedule"),
      ]);
      setStatus(data);
      setSchedule(s);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { loadStatus(); }, []);

  const compose = async () => {
    setComposing(true); setMsg(""); setErr("");
    try {
      const { data } = await http.post("/admin/newsletter/compose");
      setSubject(data.subject);
      setHtml(data.html);
      setMsg(`Briefing armado · ${data.stats.articles} titulares · ${data.stats.polls_used} encuestas · ${data.stats.press} comunicados · ${data.stats.dof} DOF. Revisa y envía.`);
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setComposing(false);
    }
  };

  const saveSchedule = async (next) => {
    setSavingSched(true); setMsg(""); setErr("");
    try {
      await http.put("/admin/newsletter/schedule", next);
      setSchedule((s) => ({ ...s, ...next }));
      setMsg(next.enabled
        ? `Envío automático activado · diario ${String(next.hour_cdmx).padStart(2, "0")}:${String(next.minute_cdmx).padStart(2, "0")} CDMX.`
        : "Envío automático desactivado.");
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setSavingSched(false);
    }
  };

  const send = async (testOnly) => {
    setSending(true); setMsg(""); setErr("");
    try {
      const { data } = await http.post("/admin/newsletter/send", {
        subject, html, test_only: testOnly,
      });
      if (data.queued) {
        setMsg(`En curso · ${data.total} destinatarios. Revisa el historial en unos minutos.`);
      } else {
        const label = data.is_test ? "Prueba enviada" : "Envío completado";
        setMsg(`${label} · éxito ${data.success}/${data.total}${data.failed ? ` · ${data.failed} fallos` : ""}`);
      }
      await loadStatus();
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally {
      setSending(false);
    }
  };

  const confirmAndSend = async () => {
    if (!status?.subscribers_active) return;
    const ok = window.confirm(
      `¿Enviar a ${status.subscribers_active} suscriptor(es) activos?\n\nAsunto: ${subject}`
    );
    if (ok) await send(false);
  };

  return (
    <div data-testid="admin-newsletter-tab" className="space-y-6">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <h3 className="font-serif-display text-2xl">
          Briefing · <span className="text-rojo">{status?.subscribers_active ?? "—"}</span>
          <span className="ml-3 font-mono text-[12px] uppercase tracking-widest text-sub">
            suscriptores activos
          </span>
        </h3>
        <button
          onClick={loadStatus}
          className="border border-ink px-3 py-1 font-mono text-[11px] uppercase tracking-widest hover:bg-ink hover:text-paper transition-colors"
          data-testid="nl-refresh"
        >
          ↻ Actualizar
        </button>
      </div>

      {loading ? (
        <p className="font-mono text-sm text-sub" data-testid="nl-loading">Cargando…</p>
      ) : !status?.configured ? (
        <div className="border-2 border-rojo bg-rojo/5 p-4" data-testid="nl-not-configured">
          <p className="font-mono text-[11px] uppercase tracking-widest text-rojo mb-1">Resend no configurado</p>
          <p className="text-sm">
            Agrega <code className="font-mono bg-ink/10 px-1">RESEND_API_KEY</code> en <code className="font-mono bg-ink/10 px-1">/app/backend/.env</code> y reinicia el backend.
            Obtén tu llave gratuita en <a className="underline" href="https://resend.com/api-keys" target="_blank" rel="noreferrer">resend.com/api-keys</a>.
            El primer envío funciona desde <code className="font-mono bg-ink/10 px-1">onboarding@resend.dev</code>; para usar <code className="font-mono bg-ink/10 px-1">@politicareal.com</code> debes verificar DNS.
          </p>
        </div>
      ) : (
        <div className="grid gap-2 sm:grid-cols-3 text-sm">
          <div className="border border-ink p-3 bg-paper">
            <p className="font-mono text-[10px] uppercase tracking-widest text-sub">Remitente</p>
            <p className="font-mono break-all">{status.sender}</p>
          </div>
          <div className="border border-ink p-3 bg-paper">
            <p className="font-mono text-[10px] uppercase tracking-widest text-sub">Responder a</p>
            <p className="font-mono break-all">{status.reply_to}</p>
          </div>
          <div className="border border-ink p-3 bg-paper">
            <p className="font-mono text-[10px] uppercase tracking-widest text-sub">Activos / Total</p>
            <p className="font-mono">{status.subscribers_active} / {status.subscribers_total}</p>
          </div>
        </div>
      )}

      {/* Composer */}
      <div className="border border-ink bg-paper p-4 space-y-3">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <p className="font-mono text-[11px] uppercase tracking-widest text-sub">Composer del briefing</p>
          <button
            onClick={compose}
            disabled={composing}
            className="border border-ink bg-ink text-paper px-4 py-2 font-mono text-[11px] uppercase tracking-widest hover:bg-rojo hover:border-rojo transition-colors disabled:opacity-40"
            data-testid="nl-compose"
          >
            {composing ? "Armando…" : "↻ Armar briefing del día"}
          </button>
        </div>
        <label className="block">
          <span className="font-mono text-[11px] uppercase tracking-widest text-sub">Asunto</span>
          <input
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            maxLength={200}
            className="mt-1 w-full bg-transparent border border-ink/40 focus:border-ink outline-none px-3 py-2 font-sans rounded-none"
            data-testid="nl-subject"
          />
        </label>
        <label className="block">
          <span className="font-mono text-[11px] uppercase tracking-widest text-sub">HTML del briefing</span>
          <textarea
            value={html}
            onChange={(e) => setHtml(e.target.value)}
            rows={14}
            className="mt-1 w-full bg-transparent border border-ink/40 focus:border-ink outline-none px-3 py-2 font-mono text-sm rounded-none"
            data-testid="nl-html"
          />
        </label>

        {/* Preview */}
        <div>
          <p className="font-mono text-[11px] uppercase tracking-widest text-sub mb-1">Vista previa</p>
          <div
            className="border border-ink p-4 bg-[#F4F1EB] min-h-[120px]"
            data-testid="nl-preview"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </div>

        {msg && <p className="text-verde font-mono text-sm" data-testid="nl-msg">{msg}</p>}
        {err && <p className="text-rojo font-mono text-sm" data-testid="nl-err">{err}</p>}

        <div className="flex flex-wrap gap-2 pt-2 border-t border-rule">
          <button
            disabled={sending || !status?.configured}
            onClick={() => send(true)}
            className="border border-ink px-4 py-2 font-mono text-[12px] uppercase tracking-widest hover:bg-ink hover:text-paper transition-colors disabled:opacity-40"
            data-testid="nl-test"
          >
            {sending ? "Enviando…" : "Enviar prueba a mi correo"}
          </button>
          <button
            disabled={sending || !status?.configured || !status?.subscribers_active}
            onClick={confirmAndSend}
            className="border border-rojo bg-rojo text-paper px-4 py-2 font-mono text-[12px] uppercase tracking-widest hover:brightness-110 transition disabled:opacity-40"
            data-testid="nl-send-all"
          >
            {sending ? "Enviando…" : `Enviar a ${status?.subscribers_active ?? 0} suscriptores`}
          </button>
        </div>
      </div>

      {/* Scheduled send */}
      {schedule && (
        <div className="border-2 border-ink bg-paper p-4" data-testid="nl-schedule-card">
          <div className="flex items-start justify-between flex-wrap gap-3">
            <div>
              <p className="font-mono text-[11px] uppercase tracking-widest text-sub">Envío automático diario</p>
              <p className="font-serif-display text-xl mt-1">
                {schedule.enabled ? (
                  <span className="text-verde">● Activado</span>
                ) : (
                  <span className="text-sub">○ Desactivado</span>
                )}
              </p>
              <p className="text-xs text-sub mt-1 font-mono">
                Hora actual CDMX: {schedule.now_cdmx}
                {schedule.last_sent_day ? ` · último envío: ${schedule.last_sent_day}` : " · sin envíos previos"}
              </p>
              <p className="text-sm mt-2 max-w-xl">
                A la hora indicada (CDMX), el sistema arma automáticamente el briefing con los titulares destacados, el promedio de aprobación, comunicados y DOF, y lo envía a todos tus suscriptores activos.
              </p>
            </div>
            <div className="flex flex-col gap-2 items-end">
              <div className="flex items-center gap-2">
                <span className="font-mono text-[10px] uppercase tracking-widest text-sub">Hora</span>
                <select
                  value={schedule.hour_cdmx}
                  onChange={(e) => setSchedule((s) => ({ ...s, hour_cdmx: parseInt(e.target.value, 10) }))}
                  className="border border-ink/40 bg-transparent px-2 py-1 font-mono text-sm rounded-none"
                  data-testid="nl-sched-hour"
                >
                  {Array.from({ length: 24 }).map((_, i) => (
                    <option key={i} value={i}>{String(i).padStart(2, "0")}</option>
                  ))}
                </select>
                <span className="font-mono">:</span>
                <select
                  value={schedule.minute_cdmx}
                  onChange={(e) => setSchedule((s) => ({ ...s, minute_cdmx: parseInt(e.target.value, 10) }))}
                  className="border border-ink/40 bg-transparent px-2 py-1 font-mono text-sm rounded-none"
                  data-testid="nl-sched-minute"
                >
                  {[0, 15, 30, 45].map((m) => (
                    <option key={m} value={m}>{String(m).padStart(2, "0")}</option>
                  ))}
                </select>
                <span className="font-mono text-[10px] uppercase tracking-widest text-sub">CDMX</span>
              </div>
              <div className="flex gap-2">
                <button
                  onClick={() => saveSchedule({ enabled: !schedule.enabled, hour_cdmx: schedule.hour_cdmx, minute_cdmx: schedule.minute_cdmx })}
                  disabled={savingSched || !status?.configured}
                  className={`border px-4 py-2 font-mono text-[11px] uppercase tracking-widest transition-colors disabled:opacity-40 ${
                    schedule.enabled
                      ? "border-rojo text-rojo hover:bg-rojo hover:text-paper"
                      : "border-ink bg-ink text-paper hover:bg-verde hover:border-verde"
                  }`}
                  data-testid="nl-sched-toggle"
                >
                  {savingSched ? "Guardando…" : schedule.enabled ? "Desactivar" : "Activar"}
                </button>
                {schedule.enabled && (
                  <button
                    onClick={() => saveSchedule({ enabled: true, hour_cdmx: schedule.hour_cdmx, minute_cdmx: schedule.minute_cdmx })}
                    disabled={savingSched}
                    className="border border-ink px-4 py-2 font-mono text-[11px] uppercase tracking-widest hover:bg-ink hover:text-paper transition-colors disabled:opacity-40"
                    data-testid="nl-sched-save-time"
                  >
                    Guardar hora
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* History */}
      <div className="border border-ink bg-paper">
        <div className="px-3 py-2 border-b border-ink bg-ink text-paper">
          <p className="font-mono text-[11px] uppercase tracking-widest">Historial de envíos</p>
        </div>
        {(!status?.history || status.history.length === 0) ? (
          <p className="px-3 py-3 text-sm text-sub" data-testid="nl-history-empty">Aún no hay envíos.</p>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-ink/5">
              <tr>
                <th className="px-3 py-2 text-left font-mono text-[11px] uppercase tracking-widest">Fecha</th>
                <th className="px-3 py-2 text-left font-mono text-[11px] uppercase tracking-widest">Asunto</th>
                <th className="px-3 py-2 font-mono text-[11px] uppercase tracking-widest">Tipo</th>
                <th className="px-3 py-2 font-mono text-[11px] uppercase tracking-widest">Estado</th>
                <th className="px-3 py-2 font-mono text-[11px] uppercase tracking-widest">OK / Total</th>
              </tr>
            </thead>
            <tbody>
              {status.history.map((h) => (
                <tr key={h.id} className="border-t border-rule" data-testid={`nl-history-${h.id}`}>
                  <td className="px-3 py-2 font-mono text-xs">{(h.created_at || "").slice(0, 16).replace("T", " ")}</td>
                  <td className="px-3 py-2 truncate max-w-[40ch]" title={h.subject}>{h.subject}</td>
                  <td className="px-3 py-2 text-center font-mono text-xs">{h.is_test ? "prueba" : "masivo"}</td>
                  <td className="px-3 py-2 text-center font-mono text-xs">
                    {h.status === "running" ? <span className="text-sub">en curso</span>
                      : h.status === "error" ? <span className="text-rojo">error</span>
                      : <span className="text-verde">listo</span>}
                  </td>
                  <td className="px-3 py-2 text-center font-mono">{h.success}/{h.total}{h.failed ? ` · ${h.failed} err` : ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
